import { useState } from 'react';
import styled from 'styled-components';
import { AutoComplete } from 'antd';
import { Circle } from '@phosphor-icons/react';
import { ActiveText, ColoredPill } from '../../elements';
import { theme } from '../../utility';
import {
  useDebounce,
  useAutocompleteLoading,
  waveRuleAutocompleteHook,
} from '../../hooks';
import { AutocompleteSearchInput } from '../../components';

const OptionContainer = styled.div`
  padding: 8px 12px;
  display: flex;
  min-width: fit-content;
`;

const PackagingMaterialName = styled(ActiveText)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

function resultRenderer({ search, _id, name, isActive }) {
  const showResult = string => {
    try {
      const highlighted = string.replace(
        new RegExp(search, 'gi'),
        d => `<strong>${d}</strong>`,
      );

      return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
    } catch (error) {
      return string;
    }
  };

  return (
    <OptionContainer key={_id}>
      <div className="d-flex align-items-center">
        <PackagingMaterialName title={name} className="mr-2">
          {showResult(name)}
        </PackagingMaterialName>
      </div>
      <ColoredPill color={isActive ? theme.colors.green : theme.colors.grey}>
        <Circle weight="fill" />
        {isActive ? 'Active' : 'Not Active'}
      </ColoredPill>
    </OptionContainer>
  );
}

export function WaveRuleSearchInput({
  top,
  onResultClick,
  inputClassName,
  setTableSearch = () => {},
  warehouseId,
}) {
  const [search, setSearch] = useState('');

  const finalSearch = useDebounce(search, 1000, 0);

  const { data, loading } = waveRuleAutocompleteHook(warehouseId, finalSearch);
  const isSearching = useAutocompleteLoading(search, finalSearch, loading);

  const options = (data ?? []).map(item => ({
    value: item._id,
    label: resultRenderer({ ...item, search }),
  }));

  return (
    <AutoComplete
      className={inputClassName}
      style={{ width: '100%' }}
      value={search}
      options={options}
      filterOption={false}
      placeholder="Wave Rule"
      placement={top ? 'topLeft' : 'bottomLeft'}
      classNames={{ popup: { root: 'auto-search-dropdown' } }}
      onSearch={value => {
        setSearch(value);
        setTableSearch(value);
      }}
      onSelect={value => {
        const item = data.find(d => d._id === value);
        if (item?._id) {
          onResultClick(item);
          setSearch('');
        }
      }}
    >
      <AutocompleteSearchInput
        isSearching={isSearching}
        onClear={() => {
          setSearch('');
          setTableSearch('');
        }}
      />
    </AutoComplete>
  );
}
